import { makeAutoObservable } from "mobx";
import { socialMediaSubscribeRequest } from "../requests";
import type { RootStore } from "stores/rootStore";

export class SocialMediaStore {
  root: RootStore;

  showSocialMediaForm: boolean = false;
  sharedPlatform: 'linkedin' | 'twitter' | 'facebook' | null = null;
  lastWordCount: number = 0;

  constructor(root: RootStore) {
    this.root = root;
    makeAutoObservable(this);
  }

  closeModal() {
    this.showSocialMediaForm = false;
  }

  hasShared() {
    return localStorage.getItem('socialMediaShared') === 'true';
  }

  isDontShowAgain() {
    return localStorage.getItem('socialMediaDontShow') === 'true';
  }

  dontShowAgain() {
    localStorage.setItem('socialMediaDontShow', 'true');
    this.showSocialMediaForm = false;
  }

  onShare(platform: 'linkedin' | 'twitter' | 'facebook') {
    this.sharedPlatform = platform;
  }

  async onCheckSharing(link: string) {
    if (this.sharedPlatform) {
      try {
        await socialMediaSubscribeRequest(this.sharedPlatform, link);
      } catch (e) {
        this.root.toast.error('share-check-error', e);
        return;
      }
      localStorage.setItem('socialMediaShared', 'true');
      this.showSocialMediaForm = false;
    }
  }

  refreshSocial() {
    if (!this.root.user.isAuthenticated()) return;
    const user = this.root.getUser();
    if (this.lastWordCount === 0 || Number.isNaN(this.lastWordCount)) {
      this.lastWordCount = Math.floor((user?.used_words_simple_scan as number) / 5000) * 5000;
    }

    const wordCount = (user as any).used_words_simple_scan as number;

    const shouldShowBasedOnWordCount =
      (wordCount >= 9500 && this.lastWordCount < 9500) ||
      (wordCount >= 10000 && wordCount - this.lastWordCount >= 5000);

    if (shouldShowBasedOnWordCount) {
      this.lastWordCount = Math.floor(wordCount / 5000) * 5000;
    }

    if (shouldShowBasedOnWordCount && !this.hasShared() && !this.isDontShowAgain() && this.root.user.isFree()) {
      this.showSocialMediaForm = true;
    }
  }
}
